import Vue from "vue";
import VueRouter from "vue-router";
import NotFound from "@/components/NotFound";

Vue.use(VueRouter);

const routes = [
  {
    name: "SuccessPayment",
    path: "/verify/:gateName/:resultCode",
    components: {
      custom: async () => import("@/pages/SuccessPayment")
    },
    meta: {
      authName: "NotRequired"
    },
    props: true
  },
  {
    name: "Payment",
    path: "/payment/:paymentId",
    components: {
      custom: async () => import("@/pages/OnlinePayment")
    },
    meta: {
      authName: "NotRequired"
    },
    props: true
  },
  {
    name: "InvestPayment",
    path: "/InvestPayment/:paymentId/:Amnt",
    components: {
      custom: async () => import("@/pages/InvestPayment")
    },
    meta: {
      authName: "NotRequired"
    },
    props: true
  },
  {
    name: "Prop",
    path: "/Prop/:policyNo",
    components: {
      custom: async () => import("@/pages/ProposalToPrint")
    },
    meta: {
      authName: "NotRequired"
    },
    props: true
  },
  {
    name: "QrCodePolicy",
  path: "/QrCode/:policyNo",
  components: {
    custom: async () => import("@/pages/QrCodePolicy")
    },
    meta: {
      authName: "NotRequired"
    },
    props: true
  },
  
  {
    name: 'default',
    path: '*',
    component: async () => NotFound,
    meta: {
      authName: 'abr'
    }
  }
];

const router = new VueRouter({
  mode: "history",
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return { selector: to.hash };
    } else if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

export default router;
